import { useCallback } from 'react';

import { DynamicFeatureFlag, useFeatureFlag } from '@sbu/hooks.featureflag';
import {
  EventProperties,
  trackEvent,
  TrackEventName,
} from '@sbu/utils.tracking';

export const useTrackEvent = () => {
  const isFeatureEnabled = useFeatureFlag(DynamicFeatureFlag.Pendo);

  return useCallback(
    (eventName: TrackEventName, eventProperties?: EventProperties) => {
      if (isFeatureEnabled) {
        trackEvent({ eventName, eventProperties });
      }
    },
    [isFeatureEnabled]
  );
};
